(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boutique-home"] && !Shopify.designMode) return;
  try {
    

(() => {
 function init(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const heroCarousel = root.querySelector('[data-home-hero-carousel]');
  if (heroCarousel) {
   const heroSlides = [...heroCarousel.querySelectorAll('[data-home-hero-slide]')];
   const heroButtons = [...heroCarousel.querySelectorAll('[data-home-hero-select]')];
   const toggle = heroCarousel.querySelector('[data-home-hero-toggle]');
   const enabled = heroCarousel.dataset.autoplay === 'true';
   const interval = Math.min(12, Math.max(4, Number(heroCarousel.dataset.interval) || 6)) * 1000;
   const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
   const controller = new AbortController();
   const options = { signal: controller.signal };
   let current = 0, timer = null, paused = false, hovered = false, focused = false, visible = true, destroyed = false;
   function stopTimer() {
    if (timer !== null) { window.clearTimeout(timer); timer = null; }
   }
   function syncTimer() {
    stopTimer();
    toggle.hidden = !enabled || motion.matches;
    toggle.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
    if (!enabled || paused || hovered || focused || !visible || document.hidden || motion.matches || destroyed) return;
    timer = window.setTimeout(() => {
     timer = null;
     showHero((current + 1) % heroSlides.length);
     syncTimer();
    }, interval);
   }
   function showHero(index) {
    current = index;
    heroSlides.forEach((slide, i) => { slide.hidden = i !== index; slide.setAttribute('aria-hidden', String(i !== index)); });
    heroButtons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
   }
   function selectHero(index) { paused = true; showHero(index); syncTimer(); }
   heroButtons.forEach((button, index) => {
    button.addEventListener('click', () => selectHero(index), options);
    button.addEventListener('keydown', event => {
     if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
     event.preventDefault();
     const next = event.key === 'Home' ? 0 : event.key === 'End' ? heroButtons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + heroButtons.length) % heroButtons.length;
     selectHero(next);
     heroButtons[next].focus();
    }, options);
   });
   toggle.addEventListener('click', () => { paused = !paused; syncTimer(); }, options);
   heroCarousel.addEventListener('pointerenter', () => { hovered = true; syncTimer(); }, options);
   heroCarousel.addEventListener('pointerleave', () => { hovered = false; syncTimer(); }, options);
   heroCarousel.addEventListener('focusin', () => { focused = true; syncTimer(); }, options);
   heroCarousel.addEventListener('focusout', event => { focused = heroCarousel.contains(event.relatedTarget); syncTimer(); }, options);
   heroCarousel.addEventListener('click', event => { if (event.target.closest('a')) { paused = true; syncTimer(); } }, options);
   document.addEventListener('visibilitychange', syncTimer, options);
   motion.addEventListener('change', syncTimer, options);
   let observer = null;
   if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => { visible = entries.some(entry => entry.isIntersecting); syncTimer(); }, { threshold: 0.15 });
    observer.observe(heroCarousel);
   }
   function destroyHero() { destroyed = true; stopTimer(); observer?.disconnect(); controller.abort(); }
   document.addEventListener('shopify:section:unload', event => { if (event.target === root || event.target.contains(root)) destroyHero(); }, options);
   heroCarousel.dataset.enhanced = 'true';
   showHero(0);
   heroCarousel.querySelector('[data-home-hero-controls]').hidden = false;
   syncTimer();
  }
  const cards = [...root.querySelectorAll('.product[data-type]')];
  const buttons = [...root.querySelectorAll('[data-filter]')];
  const count = root.querySelector('[data-piece-count]');
  function filter(value) {
   let visible = 0;
   cards.forEach(card => {card.hidden = value !== 'all' && card.dataset.type !== value; if (!card.hidden) visible++;});
   buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === value)));
   count.textContent = count.dataset.countTemplate.replace('__COUNT__', String(visible));
  }
  buttons.forEach(button => {button.hidden = button.dataset.filter !== 'all' && !cards.some(card => card.dataset.type === button.dataset.filter);});
  root.querySelector('[data-filter-row]').hidden = cards.length === 0;
  root.addEventListener('click', event => {
   const swatch = event.target.closest('[data-home-color]');
   if (swatch && root.contains(swatch)) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const card = swatch.closest('.product');
    card.querySelectorAll('[data-home-color]').forEach(item => item.setAttribute('aria-current', String(item === swatch)));
    const image = card.querySelector('.product-photo img');
    if (image && swatch.dataset.imageSrc) {
     image.srcset = swatch.dataset.imageSrcset || '';
     image.src = swatch.dataset.imageSrc;
     image.alt = swatch.dataset.imageAlt;
    }
    const photoLink = card.querySelector('.product-photo');
    photoLink.href = swatch.href;
    photoLink.setAttribute('aria-label', swatch.dataset.imageAlt);
    card.querySelector('h3 a').href = swatch.href;
    card.querySelector('[data-selected-color]').textContent = swatch.dataset.colorName;
    const price = card.querySelector('.price');
    price.textContent = '';
    if (swatch.dataset.comparePrice) {
     const previous = document.createElement('s');
     previous.textContent = swatch.dataset.comparePrice;
     price.append(previous, document.createTextNode(' '));
    }
    price.append(document.createTextNode(swatch.dataset.price));
    card.querySelector('[data-home-availability]').hidden = swatch.dataset.available === 'true';
    return;
   }

   const control = event.target.closest('[data-filter], [data-filter-link]');
   if (control) filter(control.dataset.filter || control.dataset.filterLink);
  });
  root.addEventListener('shopify:block:select', () => filter('all'));
  filter('all');
 }
 document.querySelectorAll('[data-boutique-home]').forEach(init);
 document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-boutique-home]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();
})();
